import { render, staticRenderFns } from "./UserGetTable.vue?vue&type=template&id=06f9e0a2&scoped=true&"
import script from "./UserGetTable.vue?vue&type=script&lang=js&"
export * from "./UserGetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06f9e0a2",
  null
  
)

export default component.exports